module.exports = __webpack_public_path__ + "static/media/users.1fd3ef7f.svg";